<template v-if="user">
  <div class="all-wrapper with-side-panel solid-bg-all">
     <div class="layout-w">
       <app-sidebar></app-sidebar>
       <div class="content-w">
         <app-navbar></app-navbar>
         <div class="content-i">
           <div class="content-box">
             <div class="col-sm-5">
               <div class="user-profile compact">
                 <div class="up-head-w" :style="{backgroundImage: 'url('+require('../../assets/img/de_dust2_night.jpg')+')'}">
                     <div class="up-social">
                       <a href="#"><i class="os-icon os-icon-facebook"></i></a>
                       <a href="#"><i class="os-icon os-icon-twitter"></i></a>
                       <a href="#"><i class="os-icon os-icon-instagram"></i></a>
                       <a href="#"><i class="fab fa-youtube"></i></a>
                       <a href="#"><i class="fab fa-twitch"></i></a>
                       <a href="#"><i class="fab fa-steam"></i></a>
                     </div>
                     <div class="up-main-info">
                         <h2 class="up-header">{{ this.user_profile.user.username }}</h2>
                         <h6 class="up-sub-header">
                           <div class="value badge badge-pill badge-primary" v-if="this.user_profile.player.createdAt.includes('2018')">Legendary</div>&nbsp;
                           <div class="value badge badge-pill badge-primary" v-if="this.user_profile.player.rank.name === 'player'">Player</div>
                           <div class="value badge badge-pill badge-success" v-if="this.user_profile.player.rank.name === 'Premium'">Premium</div>
                           <div class="value badge badge-pill badge-warning" v-if="this.user_profile.player.rank.name === 'Premium+'">Premium+</div>
                           <div class="value badge badge-pill badge-danger" v-if="this.user_profile.player.rank.name === 'admin'">Admin</div>
                           <div class="value badge badge-pill badge-danger" v-if="this.user_profile.player.rank.name === 'owner'">Owner</div>
                         </h6>
                    </div>
                 </div>
                 <div class="up-controls">
                   <div class="row">
                     <div class="col-sm-6">
                       <div class="value-pair">
                         <div class="label">Status:</div>&nbsp;
                         <div class="value badge badge-pill badge-success" v-if="this.user_profile.player.online">Online</div>
                         <div class="value badge badge-pill badge-danger" v-if="!this.user_profile.player.online">Offline</div>
                       </div>
                     </div>
                   </div>
                 </div>
                 <div class="up-contents">
                   <div class="m-b">
                     <div class="row m-b">
                       <div class="col-sm-6 b-r b-b">
                         <div class="el-tablo centered padded-v">
                           <div class="value">{{ this.user_profile.player.country }}</div>
                           <div class="label">Country of Origin</div>
                         </div>
                       </div>
                       <div class="col-sm-6 b-b">
                         <div class="el-tablo centered padded-v">
                           <div class="value">{{ this.user_profile.player.totalJoined }}x</div>
                           <div class="label">Joined onetap</div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="element-wrapper" v-if="this.$root.isAuthenticated">
                   <div class="element-box">
                       <h6 class="element-header">User Settings</h6>
                       <div class="timed-activities compact">
                           <div class="timed-activity">
                               <div class="ta-date"><span>21st Jan, 2017</span></div>
                               <div class="ta-record-w">
                                   <div class="ta-record">
                                       <div class="ta-timestamp"><strong>11:55</strong> am</div>
                                       <div class="ta-activity">Created a post called <a href="#">Register new symbol</a> in Rogue</div>
                                   </div>
                                   <div class="ta-record">
                                       <div class="ta-timestamp"><strong>2:34</strong> pm</div>
                                       <div class="ta-activity">Commented on story <a href="#">How to be a leader</a> in <a href="#">Financial</a> category</div>
                                   </div>
                                   <div class="ta-record">
                                       <div class="ta-timestamp"><strong>7:12</strong> pm</div>
                                       <div class="ta-activity">Added <a href="#">John Silver</a> as a friend</div>
                                   </div>
                               </div>
                           </div>
                           <div class="timed-activity">
                               <div class="ta-date"><span>3rd Feb, 2017</span></div>
                               <div class="ta-record-w">
                                   <div class="ta-record">
                                       <div class="ta-timestamp"><strong>9:32</strong> pm</div>
                                       <div class="ta-activity">Added <a href="#">John Silver</a> as a friend</div>
                                   </div>
                                   <div class="ta-record">
                                       <div class="ta-timestamp"><strong>5:14</strong> pm</div>
                                       <div class="ta-activity">Commented on story <a href="#">How to be a leader</a> in <a href="#">Financial</a> category</div>
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
             </div>
             <app-darkcolor></app-darkcolor>
             <app-invitation v-if="this.$root.authenticated"></app-invitation>
           </div>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
import Navbar from '../partials/Navbar.vue';
import Sidebar from '../partials/Sidebar.vue';
import Alert from '../partials/Alert';
import DarkColor from '../partials/DarkColor';
import RightSidebar from '../partials/RightSidebar';
import Invitation from '../partials/Invitation';
import Select2 from '../partials/Select2';

export default {
  name: 'Statistics',
  metaInfo: {
    title: 'statistics',
    titleTemplate: 'onetap | %s',
    meta: [
      { property: 'og:title', content: 'onetap | statistics' },
      { property: 'og:site_name', content: 'onetap' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://onetap.gg/servers'},
      { property: 'og:description', content: 'Providing public & private CS:GO servers' },
      { itemprop: 'name', content: 'onetap | statistics' },
      { itemprop: 'description', content: 'Providing public & private CS:GO servers'},
    ]
  },
  data() {
    return {
      user_id: null,
      discrim: null,
      user_profile: {
        "user":{
           "username":"nanankcornering",
           "discriminator":"1337",
           "full_name":"Nanank Cornering"
        },
        "player":{
           "rank":{
              "name":"player",
              "expiresAt":0
           },
           "status":{
              "banned":false,
              "reason":"kamu ngomongnya jangan kasar dong :( by undefined",
              "expire":1545203905842
           },
           "stats":{
              "multi1v1":{
                 "kills":113,
                 "deaths":137,
                 "assists":0,
                 "wins":117,
                 "losses":218,
                 "rounds":335
              },
              "pug":{
                 "kills":23,
                 "deaths":56,
                 "assists":4,
                 "wins":20,
                 "losses":35,
                 "rounds":55
              },
              "retakes":{
                 "kills":26,
                 "deaths":67,
                 "assists":5,
                 "wins":38,
                 "losses":88,
                 "rounds":126
              },
              "awp":{
                 "kills":0,
                 "deaths":0,
                 "assists":0,
                 "wins":0,
                 "losses":0,
                 "rounds":0
              },
              "deathmatch":{
                 "kills":7,
                 "deaths":16,
                 "assists":0,
                 "wins":0,
                 "losses":0,
                 "rounds":0
              },
              "dangerzone":{
                 "kills":0,
                 "deaths":0,
                 "assists":0,
                 "wins":0,
                 "losses":0,
                 "rounds":0
              }
           },
           "session":{
              "team":null,
              "server":null
           },
           "_id":"5b7d469538e79b723cb62fe5",
           "id":"STEAM_1:0:95443740",
           "avatar":"https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/7b/7b46d395060eb90707460ae671466ae1b9ec49a9_full.jpg",
           "country":"SG",
           "username":"nanank",
           "online":false,
           "isFree":false,
           "joinRemaining":4,
           "totalJoined":221,
           "discord_connected":true,
           "discord_id":"100926239937662976"
        }
      },
      welcomeText: 'Welcome to onetap!',
      instagram: null,
      facebook: null,
      twitter: null,
      steamcommunity: null,
      twitch: null,
      youtube: null
    }
  },
  computed: {
    //
  },
  methods: {
    getUserProfile() {
      let discrim = this.$route.hash.replace('#', '');
      let user_id = this.$route.params.user_id;
      this.axios.get(`${this.API_URL}/apollo/profile/${user_id}${discrim}`).then((res) => {
        this.user_profile = res.data;
      }).catch((res) => {
        //
      })
    },
    detectMob() {
     if( navigator.userAgent.match(/Android/i)
     || navigator.userAgent.match(/webOS/i)
     || navigator.userAgent.match(/iPhone/i)
     || navigator.userAgent.match(/iPad/i)
     || navigator.userAgent.match(/iPod/i)
     || navigator.userAgent.match(/BlackBerry/i)
     || navigator.userAgent.match(/Windows Phone/i)
     ){
        return true;
      }
     else {
        return false;
      }
    }
  },
  created() {
    window.$('body').addClass('before-body menu-position-side menu-side-left full-screen with-content-panel');
    this.getUserProfile();
  },
  mounted() {
    //
  },
  components: {
    'app-navbar': Navbar,
    'app-sidebar': Sidebar,
    'app-alert': Alert,
    'app-rightsidebar': RightSidebar,
    'app-invitation': Invitation,
    'app-select2': Select2
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
